import { data } from '../../svg/Pause/data';
import { makeIcon } from '../makeIcon';

export const Pause = makeIcon(data, 'pause', 'Pause');

export default Pause;
